import React from "react";
import { useNavigate } from "react-router-dom";

export default function ErrorPage({ error, notFound = false }) {
  const navigate = useNavigate();
  const reference = notFound ? "PAGE-NOT-FOUND" : "ERP-UNEXPECTED-ERROR";
  return (
    <div className="harwin-error-page">
      <div className="harwin-error-card">
        <div className="harwin-error-code">{notFound ? "404" : "!"}</div>
        <h1>Something went wrong!</h1>
        <p className="harwin-error-message">
          {notFound
            ? "The page you requested could not be found or may no longer be available."
            : "The application could not complete this request. Please try again."}
        </p>
        {error?.message ? (
          <div className="harwin-error-detail">{error.message}</div>
        ) : null}
        <div className="harwin-error-ref">
          <strong>Error Reference:</strong> {reference}
        </div>
        <div className="harwin-error-actions">
          <button
            type="button"
            className="secondary"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
          <button
            type="button"
            className="primary"
            onClick={() => navigate("/dashboard", { replace: true })}
          >
            Go to Dashboard
          </button>
        </div>
        <div className="harwin-error-help">
          <strong>Need Help?</strong> Contact Administrator / Technical Team —
          Aalan TechSoft.
        </div>
      </div>
      <style>{`
        .harwin-error-page{min-height:calc(100vh - 90px);display:flex;align-items:center;justify-content:center;padding:32px;background:#f8fafc;font-family:inherit}
        .harwin-error-card{width:min(620px,100%);background:#fff;border:1px solid #e2e8f0;border-radius:18px;box-shadow:0 18px 50px rgba(15,23,42,.08);padding:42px;text-align:center}
        .harwin-error-code{width:76px;height:76px;margin:0 auto 18px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#ecfeff;color:#0f766e;font-size:25px;font-weight:800;border:1px solid #a5f3fc}
        .harwin-error-card h1{margin:0;color:#172033;font-size:30px;font-weight:800}
        .harwin-error-message{margin:12px auto 0;max-width:500px;color:#64748b;line-height:1.65;font-size:15px}
        .harwin-error-detail{margin:18px 0 0;padding:11px 14px;background:#fff7ed;border:1px solid #fed7aa;border-radius:9px;color:#9a3412;font-size:13px;word-break:break-word}
        .harwin-error-ref{margin-top:20px;color:#475569;font-size:13px}
        .harwin-error-actions{display:flex;justify-content:center;gap:12px;flex-wrap:wrap;margin-top:25px}
        .harwin-error-actions button{border-radius:9px;padding:10px 20px;font-weight:700;font-size:14px;cursor:pointer}
        .harwin-error-actions .secondary{background:#fff;color:#334155;border:1px solid #cbd5e1}
        .harwin-error-actions .primary{background:#0d9488;color:#fff;border:1px solid #0d9488}
        .harwin-error-help{margin-top:26px;padding-top:20px;border-top:1px solid #e2e8f0;color:#64748b;font-size:13px}
        @media(max-width:600px){.harwin-error-page{padding:16px}.harwin-error-card{padding:30px 20px}.harwin-error-card h1{font-size:25px}}
      `}</style>
    </div>
  );
}
